<template>
  <!-- 批量审批详情 -->
  <div class="limit-batch-approval-detail">
    <div class="text-right">
      <a-button slot="extra" @click="goBack">返回</a-button>
    </div>
    <a-card :loading="loading" title="审批流程" class="card">
      <process :process-list="sourceData.process" />
    </a-card>

    <a-card :loading="loading" title="基本信息" class="card">
      <card-view :schema="LIMIT_BATCH_BASE_INFO_SCHEMA" :source-data="sourceData">
        <template v-slot:type="slotProps">
          <span>{{ CREDIT_TYPE_OBJ[slotProps.item.value] }}</span>
        </template>

        <template v-slot:filename="slotProps">
          <a href="javascript:void(0)" @click="downloadFile">
            {{ slotProps.item.value }}
          </a>
        </template>
      </card-view>

      <!-- 申请原因及备注 -->
      <apply-reason-remark
        :content="sourceData.remark || ''"
        :attachments="sourceData.attachments"
      />
    </a-card>

    <!-- 上一级审批意见 -->
    <a-card
      title="上一级审批意见"
      :loading="loading"
      v-if="approvalList.length"
      class="card"
    >
      <approval-remark-list :approval-list="approvalList" />
    </a-card>

    <a-card title="审批意见" class="card" :loading="loading" v-if="type != 8">
      <quill-editor :token="token" ref="quillEditor"></quill-editor>
    </a-card>

    <!-- 提交 -->
    <footer-tool-bar v-if="type != 8">
      <a-button
        type="primary"
        class="margin-right-20"
        @click="handleSubmit(APPROVAL_ACTION_OBJ.PASS)"
        :loading="loading || actionLoading"
      >
        审批通过
      </a-button>
      <a-button
        type="danger"
        class="margin-right-20"
        @click="handleSubmit(APPROVAL_ACTION_OBJ.REJECT)"
        :loading="loading || actionLoading"
      >
        审批不通过
      </a-button>
      <!-- TODO: 待测 -->
      <a-button
        type="primary"
        @click="showNextApprovalModal = true"
        :loading="loading || actionLoading"
        v-if="sourceData.hasNext == 1"
      >
        更换下一阶段审批人
      </a-button>
    </footer-tool-bar>

    <!-- 更换下一阶段审批人弹框 -->
    <next-approval-modal
      v-if="sourceData.hasNext == 1"
      :visible="showNextApprovalModal"
      :action-loading="actionLoading"
      :next-approve-person="sourceData.nextApprovePerson"
      :next-approve-persons="sourceData.nextApprovePersons"
      @onSubmitModal="onSubmitNextApprovalModal"
      @onCloseModal="onCloseNextApprovalModal"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getBatchLimitDetail, doLimitBatchApprove } from './api'
import { downloadLimitBatchFile } from '../api'
import { LIMIT_BATCH_BASE_INFO_SCHEMA } from './schema'
import { APPROVAL_ACTION_OBJ } from './const'
import { CREDIT_TYPE_OBJ } from '../const'
import Process from '../components/Process.vue'
import { CardView } from 'lxfintech-fe'
import ApplyReasonRemark from '../components/ApplyDetail/ApplyReasonRemarkView.vue'
import QuillEditor from '../components/QuillEditor.vue'
import FooterToolBar from 'components/FooterToolBar.vue'
import NextApprovalModal from '../components/NextApprovalModal.vue'
import ApprovalRemarkList from '../components/ApprovalRemarkList.vue'

export default {
  name: 'limit-batch-approval-detail',
  data() {
    return {
      bpmId: '',
      type: '',
      LIMIT_BATCH_BASE_INFO_SCHEMA,
      CREDIT_TYPE_OBJ,
      APPROVAL_ACTION_OBJ,
      loading: false,
      actionLoading: false,
      sourceData: {
        id: '',
        attachments: [],
        fileName: '',
        hasNext: 0,
        maxAmount: 0,
        nextApprovePerson: '',
        nextApprovePersons: '',
        process: [],
        remark: '',
        total: 0,
        totalAmount: 0,
        type: '',
      },
      showNextApprovalModal: false,
      newNextApprovePerson: null,
    }
  },
  computed: {
    ...mapGetters('user', ['token']),
    approvalList() {
      const process = this.sourceData.process
      const list = []
      process.forEach((item, index) => {
        if (index == 0) return
        if (item.approvePerson) {
          list.push({ id: item.id, ...item.approvePerson })
        }
      })
      return list
    },
  },
  mounted() {
    const { bpmId } = this.$route.params
    const { type } = this.$route.query
    if (bpmId) {
      this.bpmId = bpmId
      this.type = type
      this._getBatchApprovalDetail(bpmId)
      return
    }
    this.$notification.warning({
      message: '提示',
      description: 'id为空',
    })
  },
  methods: {
    async _getBatchApprovalDetail(bpmId) {
      try {
        this.loading = true
        const { data } = await getBatchLimitDetail(bpmId)
        if (data) {
          for (let key in data) {
            this.sourceData[key] = data[key]
          }
        }
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    downloadFile() {
      downloadLimitBatchFile(this.sourceData.id)
    },

    /**
     * ack: 1-通过，2-不通过
     * changeNextApprovePerson: 是否为下一环节审批人
     */
    handleSubmit(ack, changeNextApprovePerson) {
      if (this.actionLoading) {
        return
      }
      let params = {
        ack,
        id: this.sourceData.id,
        remark: this.$refs.quillEditor.getContent(),
      }
      if (ack == APPROVAL_ACTION_OBJ.REJECT) {
        this._doApprove(params)
        return
      }
      // 若选择的是更换下一阶段审批人
      if (changeNextApprovePerson && this.newNextApprovePerson) {
        params.nextApprovePerson = this.newNextApprovePerson
      }
      this._doApprove(params)
    },
    async _doApprove(params) {
      this.actionLoading = true
      try {
        await doLimitBatchApprove(params)
        this.actionLoading = false
        this.$router.push({ name: 'batch-limit-list' })
      } catch (error) {
        console.error(error)
      }
    },
    onSubmitNextApprovalModal(newNextApprovePerson) {
      this.newNextApprovePerson = newNextApprovePerson
      this.handleSubmit(APPROVAL_ACTION_OBJ.PASS, true)
    },
    onCloseNextApprovalModal() {
      this.showNextApprovalModal = false
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  components: {
    Process,
    CardView,
    ApplyReasonRemark,
    QuillEditor,
    NextApprovalModal,
    FooterToolBar,
    ApprovalRemarkList,
  },
}
</script>

<style lang="less" scoped></style>
